import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import {
  timeout,
  map
} from 'rxjs/operators';


@Injectable()

export class AccessProviders{
 	server: string = 'https://appws.apa.org.py/pdf_api/';
 // server: string = 'http://10.25.25.10/apasist/servicios/app/'; //produccion
 // server: string = 'http://localhost/pruebas/';

	constructor(public http: HttpClient){}

	postData(body, file){
		let headers = new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8'
		});

		let options = {
			headers: headers
		}

	  	//console.log(this.server + file, JSON.stringify(body), options)
		return this.http.post(this.server + file, JSON.stringify(body), options)
		.pipe(
      map(res => res),
      timeout(59000)
      );
	}
}
